import { useForm } from "react-hook-form"
import InputsFields from "../../helpers/InputFields"
import { AgencyInputs } from "../../utils/listInputs/AgencyInputs";
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { useDispatch } from "react-redux";
import { useAddAgencyMutation, useUpdateAgencyMutation } from "../../store/services/AgencyService";
import { toast } from "react-toastify";

type IProps = {
    type: 'add' | 'update',
    dataInfo?: any,
}

export default function AgencyForm({ type, dataInfo }: IProps) {

    const dispatch = useDispatch();
    const form = useForm({ defaultValues: { nome: dataInfo?.nome } });
    const { handleSubmit } = form;
    const [updateAgency] = useUpdateAgencyMutation();
    const [addAgency] = useAddAgencyMutation();

    const handleSubmitAgData = async (dataForm: any) => {

        let result: any;
        const resultLabel = type === 'update' ? 'modificata' : 'creata';

        if(type === 'update') {
            result = await updateAgency({id: dataInfo.id, ...dataForm});
        } else {
            result = await addAgency(dataForm);
            dispatch(setIsOpenDialog(true));
        }

        if ('error' in result) {
            toast.error(`Azienda non ${resultLabel}! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Azienda ${resultLabel}! `)
        }

    }

    return (
        <div className="p-10 flex flex-col gap-y-8">

            <h5 className="text-[#064e3b] text-xl font-medium">
                {type === 'add' && 'Aggiungi '}
                {type === 'update' && 'Modifica '}
                azienda
            </h5>

            <form onSubmit={handleSubmit(handleSubmitAgData)}>
                <InputsFields arrFields={AgencyInputs} form={form} />

                <div className="flex justify-end my-6">
                    <button className="h-10 bg-[#064e3b] text-white px-5 w-64 rounded-lg text-md">Salva</button>
                </div>
            </form>
        </div>
    )
}